import { ComponentEventType } from './componentEvent';
/**
 * Configuration object for the event handlers.
 */
var ComponentEventHandlers = /** @class */ (function () {
    function ComponentEventHandlers() {
    }
    return ComponentEventHandlers;
}());
export { ComponentEventHandlers };
ComponentEventType.BeforeCreate, ComponentEventType.Created, ComponentEventType.BeforeMount, ComponentEventType.Mounted, ComponentEventType.BeforeUpdate, ComponentEventType.Updated, ComponentEventType.BeforeDestroy, ComponentEventType.Destroyed, ComponentEventType.Error, ComponentEventType.Data;
/**
 * Component configuration options.
 */
var ComponentOptions = /** @class */ (function () {
    function ComponentOptions() {
        this.parent = 'body';
        this.tag = 'div';
        this.handlers = new ComponentEventHandlers();
        this.resources = [];
    }
    return ComponentOptions;
}());
export { ComponentOptions };
//# sourceMappingURL=componentOptions.js.map